import React, { Component } from 'react';

class Help extends Component {
  render() {
    return (
      <div className="container-fluid">
  <div className="row">
    <div className="col">
      <h1 style={{backgroundColor: 'gray', padding: 70}}>Hello. You are in "HELP" page!</h1>
    </div>
  </div>
</div>

    );
  }
}

export default Help;